"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAccessToken = getAccessToken;
exports.getToken = getToken;
exports.removeAccessToken = removeAccessToken;
exports.removeToken = removeToken;
exports.setAccessToken = setAccessToken;
exports.setToken = setToken;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

var TokenKey = 'Authori-zation';
var AccessTokenKey = 'accessToken';
function getToken() {
  return _jsCookie.default.get(TokenKey);
}
function setToken(token) {
  return _jsCookie.default.set(TokenKey, token);
}
function removeToken() {
  return _jsCookie.default.remove(TokenKey);
}
function getAccessToken() {
  return _jsCookie.default.get(AccessTokenKey) || localStorage.getItem(AccessTokenKey) || sessionStorage.getItem(AccessTokenKey);
}
function setAccessToken(token) {
  _jsCookie.default.set(AccessTokenKey, token);
  localStorage.setItem(AccessTokenKey, token);
}
function removeAccessToken() {
  _jsCookie.default.remove(AccessTokenKey);
  localStorage.removeItem(AccessTokenKey);
  sessionStorage.removeItem(AccessTokenKey);
}